import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "_mb-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")
  const _component_text_area_field = _resolveComponent("text-area-field")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: _ctx.Resources.Comments.ReportCommentModalTitle,
    icon: "flag",
    "is-processing": _ctx.isProcessing,
    "is-visible": $data.isVisible
  }, {
    actions: _withCtx(() => [
      _createElementVNode("a", {
        href: "",
        class: "gfu-link gfu-link--accent",
        onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */),
      _createVNode(_component_icon_base_button, {
        size: "default",
        width: "compact",
        "text-transform": "none",
        wide: true,
        theme: "accent",
        icon: "check",
        enabled: !_ctx.isProcessing,
        onClick: $options.submit,
        "data-qa": "modal-button:Save"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.Common.ModalSaveButton), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["enabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.Resources.Comments.ReportCommentModalParagraph), 1 /* TEXT */),
        _createVNode(_component_option_field, {
          modelValue: $data.model.reason,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.reason) = $event)),
          name: "model.reason",
          "display-name": _ctx.Resources.Comments.ReportCommentModalReasonFieldLabel,
          options: $options.availableReportReasons,
          "no-option-capitalize": true,
          "data-qa": "report-project-comment-model:Reason"
        }, null, 8 /* PROPS */, ["modelValue", "display-name", "options"]),
        ($options.shouldShowReasonDescription)
          ? (_openBlock(), _createBlock(_component_text_area_field, {
              key: 0,
              modelValue: $data.model.reasonDescription,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.reasonDescription) = $event)),
              name: "model.reasonDescription",
              "display-name": _ctx.Resources.Comments.ReportCommentModalReasonDescriptionFieldLabel,
              "data-qa": "modal-field:ReportReasonDescription"
            }, null, 8 /* PROPS */, ["modelValue", "display-name"]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "is-processing", "is-visible"]))
}